import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn"; // Simplified Chinese
import "dayjs/locale/en"; // English

// Import local translation files
import enTranslations from "./locales/en.json";
import zhHansCNTranslations from "./locales/zh-Hans-CN.json";
import zhHantTWTranslations from "./locales/zh-Hant-TW.json";

import { detectUserLocale } from "./utils/multi-language";

const resources = {
  en: {
    translation: enTranslations,
  },
  "zh-Hans-CN": {
    translation: zhHansCNTranslations,
  },
  "zh-Hant-TW": {
    translation: zhHantTWTranslations,
  },
};

// Detect language and then initialize i18n
const initializeI18n = async () => {
  let { language } = await detectUserLocale();

  // language = "zh-Hant-TW";

  i18n.use(initReactI18next).init({
    resources,
    lng: language, // Set detected language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
      useSuspense: false,
    },
  });

  // Function to sync i18n and dayjs locales
  const updateDayjsLocale = (lng) => {
    const dayjsLocaleMap = {
      en: "en",
      "zh-Hans-CN": "zh-cn",
    };
    const dayjsLocale = dayjsLocaleMap[lng] || "en"; // Default to English
    dayjs.locale(dayjsLocale);
  };

  // Initialize i18n and sync with dayjs
  i18n.on("languageChanged", (lng) => {
    updateDayjsLocale(lng);
  });
};

// Call initialization
initializeI18n();

export default i18n;

export async function refreshI18n() {
  const { language } = await detectUserLocale();
  i18n.changeLanguage(language);
}
